import React from 'react';

function Loading({ message }) {
  return (
    <div className="flex items-center justify-center h-full bg-zinc-200 w-full">
      <div className="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-lg flex flex-col items-center space-y-4">
        <div className="relative flex items-center justify-center w-60 h-60">
          <figure className="relative flex items-center justify-center w-full h-full iconLoaderProgress">
            <svg
              className="absolute w-full h-full iconLoaderProgressFirst"
              viewBox="0 0 240 240"
            >
              <circle
                cx="120"
                cy="120"
                r="100"
                className="stroke-[#7c57f4] stroke-[16px] fill-none stroke-linecap-round"
              ></circle>
            </svg>
            <svg
              className="absolute w-full h-full iconLoaderProgressSecond"
              viewBox="0 0 240 240"
            >
              <circle
                cx="120"
                cy="120"
                r="100"
                className="stroke-[#bfb2f7] stroke-[16px] fill-none stroke-linecap-round"
              ></circle>
            </svg>
          </figure>
        </div>
        <div className="text-black text-xl font-medium text-center">
          {message || 'Chargement en cours...'}
        </div>
      </div>
    </div>
  );
}

export default Loading;